import {
  GET_ALL_REPORTED_PROPERTIES,
  GET_REPORTED_PROPERTY_DETAILS,
} from "./actions";

const initialState = {
  reportedProperty: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getReportedPropertyDetails: {},
  loading: true,
};

const reportPropertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_REPORTED_PROPERTIES:
      return {
        ...state,
        reportedProperty: payload,
        loading: false,
      };
    case GET_REPORTED_PROPERTY_DETAILS:
      return {
        ...state,
        getReportedPropertyDetails: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default reportPropertyReducer;
